import { StatusServerlessProject } from '@/service/serverless-gpu/type';
import BadgeProjectStatus from '../../components/BadgeProjectStatus';
import { Button } from '@/components/ui/button';
import { SettingsIcon } from 'lucide-react';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { Link } from 'react-router-dom';

const HeaderLayout = ({
  projectId,
  projectName,
  status,
}: {
  projectId: string;
  projectName: string;
  status: StatusServerlessProject;
}) => {
  const { workspaceId } = useParamWorkspaceId();

  return (
    <div className="flex items-center gap-2">
      <p className="text-lg font-semibold">{projectName || projectId}</p>
      <BadgeProjectStatus status={status} />
      {status === StatusServerlessProject.Active && (
        <div className="ml-auto flex items-center gap-2">
          <Link
            to={
              PATH_PAGE.dashboard.serverlessGPU.byId(workspaceId, projectId)
                .setting
            }
          >
            <Button variant="ghost" size="icon" className="ml-auto">
              <SettingsIcon className="size-4" />
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default HeaderLayout;
